import { ColumnFilterPopover } from '@components/popover/columnsFilterPopover';
import { useOrdersTable } from '@components/tables/orders';
import { useToggleTableColumns } from '@hooks/useToggleTableColumns';
import { BaseLayout } from '@layouts/base';
import { Order } from '@root/globalTypes';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function AgreementOrders({
  orders,
  onRowSelect,
}: {
  orders: Order[];
  onRowSelect: (id: string) => void;
}) {
  const { t } = useTranslation('app');
  const predefinedCols = useMemo(
    () => [
      'id',
      'amount',
      'currency',
      'source_type',
      'scheme',
      'source',
      'created_at',
      'updated_at',
    ],
    [],
  );
  const { visibleColumns, setColumns } = useToggleTableColumns({ predefinedCols });
  const { columns, Table: OrdersTable } = useOrdersTable({
    data: orders,
    onRowSelect,
    visibleColumns,
  });

  return (
    <BaseLayout
      title={t('pages.orders.title')}
      actions={[
        <ColumnFilterPopover
          key="colFilter"
          activeCols={visibleColumns}
          setActiveCols={setColumns}
          columns={columns.map((col) => ({ id: col.id as string, label: col.header as string }))}
          defaultColumns={predefinedCols}
        />,
      ]}>
      <OrdersTable />
    </BaseLayout>
  );
}
